export const paginationOptions = [10, 25, 50, 100];

export const gridPaginationOptions = [12, 30, 60, 120];
